import m from 'mithril'

const Component = {

    view: function (vnode) {

        return [

            m('.full_fog',
                {
                    id: 'fog',
                    class: vnode.attrs.fog_class || '',
                    onclick: (e) => {
                        if (vnode.attrs.on_click_outside && e.target.id == 'fog') vnode.attrs.on_click_outside()
                    }
                },
                m('.my_popup',

                    {
                        class: vnode.attrs.class || ''
                    },
                    vnode.children
                )
            )
        ]
    }
}


export default Component